import type { ItemType } from '../types/item';
import type { AccountSubType, GlAccount } from '../types/account';

export interface ItemGlAccountDefaults {
  income_account_id: string;
  expense_account_id: string;
  asset_account_id: string;
}

const findAccountBySubType = (accounts: GlAccount[], subType: AccountSubType) =>
  accounts.find((a) => a.active && a.account_sub_type === subType);

/** Picks default GL accounts by item type using standard account sub-types. */
export const getDefaultGlAccountsForItemType = (
  itemType: ItemType,
  accounts: GlAccount[]
): ItemGlAccountDefaults => {
  const salesRevenue = findAccountBySubType(accounts, 'SALES_REVENUE');
  const cogs = findAccountBySubType(accounts, 'COGS');
  const inventoryAsset = findAccountBySubType(accounts, 'INVENTORY_ASSET');

  const income_account_id = salesRevenue ? String(salesRevenue.id) : '';

  switch (itemType) {
    case 'INVENTORY':
      return {
        income_account_id,
        asset_account_id: inventoryAsset ? String(inventoryAsset.id) : '',
        expense_account_id: cogs ? String(cogs.id) : '',
      };
    case 'NON_INVENTORY':
      return {
        income_account_id,
        asset_account_id: '',
        expense_account_id: cogs ? String(cogs.id) : '',
      };
    case 'SERVICE':
    default:
      return {
        income_account_id,
        asset_account_id: '',
        expense_account_id: '',
      };
  }
};

export const applyGlDefaultsIfEmpty = (
  current: ItemGlAccountDefaults,
  itemType: ItemType,
  accounts: GlAccount[]
): ItemGlAccountDefaults => {
  const defaults = getDefaultGlAccountsForItemType(itemType, accounts);
  return {
    income_account_id: current.income_account_id || defaults.income_account_id,
    expense_account_id: current.expense_account_id || defaults.expense_account_id,
    asset_account_id: current.asset_account_id || defaults.asset_account_id,
  };
};
